const DEFAULT_DATE_TIME_LOCALE = "en-US";

export function formatDateTime(dateString?: string | null, options?: Intl.DateTimeFormatOptions): string {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "Invalid Date";

  return new Intl.DateTimeFormat(DEFAULT_DATE_TIME_LOCALE, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    ...options,
  }).format(date);
}

export function formatDateOnly(dateString?: string | null, options?: Intl.DateTimeFormatOptions): string {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "Invalid Date";

  return new Intl.DateTimeFormat(DEFAULT_DATE_TIME_LOCALE, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    ...options,
  }).format(date);
}
